export default __webpack_public_path__ + "static/media/favorites.46d244bc.webp";